import React from 'react';
import Link from 'next/link';

import { FlowCard, FlowCardProps } from './FlowCard';

export interface FlowCardLinkProps extends FlowCardProps {
  href: string;
}

export const FlowCardLink: React.FC<FlowCardLinkProps> = ({
  title,
  subtitle,
  badgeLabel,
  badgeColor,
  image,
  href,
}) => (
  <Link href={href}>
    <a>
      <FlowCard
        title={title}
        subtitle={subtitle}
        badgeColor={badgeColor}
        badgeLabel={badgeLabel}
        image={image}
        showArrow
      />
    </a>
  </Link>
);
